import React from "react";
import styled from "styled-components";

const PointWrapper = styled.div`
    display: flex;
    align-items: center;
   
    svg{
       margin-right: 20px;
    }
    .dot{
        display: block;
        width: 14px;
        height: 14px;
        border-radius: 7px;
        background: #DE443D;
      
        padding: 0;
    }
    p{
      flex: 1;
      font-weight: bold;
      color: #515151;
    }
`

const Wrapper = styled.div`

`

const MainWrapper = styled.div`
    display: flex;
    min-height: 50vw;
    height: auto;
    padding: 50px 5vw;
    
    align-items: center;
     @media only screen and (max-width: 1000px) {
      flex-direction: column;
    }
    .imageWrapper{
      width: 30vw;
   
      @media only screen and (max-width: 1000px) {
       display: none;
      }
      padding: 2vw 4vw;
    }
    
`
const ImageWrapper = styled.div`
  img{
      width: 100%;
  }
`


const Point = ({children}) => (
    <PointWrapper>
        <svg width="15" height="15" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.543945 12.3838C0.543945 19.1258 6.00995 24.5918 12.7519 24.5918C19.4949 24.5918 24.9609 19.1258 24.9609 12.3838C24.9609 5.6418 19.4949 0.175797 12.7519 0.175797C6.00995 0.175797 0.543945 5.6418 0.543945 12.3838Z" fill="#DE443D"/>
        </svg>
        <p>{children}</p>
    </PointWrapper>
)

const WhoBlock = () => (
    <MainWrapper className={'b10'}>
        <ImageWrapper className={'imageWrapper'}>
            <img src={'/block-1.jpg'}/>
        </ImageWrapper>
        <Wrapper>
            <h2>ЧЕЙ ЭТО УЛЬТИМАТУМ?</h2>
            <Point>Всех, кто не готов мириться с беспределом силовиков и чиновников.</Point>
            <Point>Всех, чьи голоса на выборах президента бессовестно украли.</Point>
            <Point>Всех, кто не может оставить всё так, как есть.</Point>
        </Wrapper>
    </MainWrapper>
)

export default WhoBlock;
